import React from 'react';
import { Box, BoxProps } from '@mui/material';

interface NeonGlassItemProps extends BoxProps {
    children: React.ReactNode;
    isClickable?: boolean;
}

export const NeonGlassItem = React.forwardRef<HTMLDivElement, NeonGlassItemProps>(
    ({ children, sx, isClickable, ...props }, ref) => {
        const baseStyles = {
            p: 2,
            border: '1px solid rgba(255,255,255,0.1)',
            borderRadius: 1,
            transition: 'all 0.3s ease',
            cursor: isClickable ? 'pointer' : 'default',
            '&:hover': {
                background: 'rgba(255, 255, 255, 0.05)',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                boxShadow: '0 8px 25px rgba(0, 0, 0, 0.3)',
                ...(isClickable && {
                    transform: 'translateY(-2px)',
                }),
            },
        };

        return (
            <Box
                ref={ref}
                sx={{
                    ...baseStyles,
                    '&:hover': {
                        ...baseStyles['&:hover'],
                        ...(sx as any)?.['&:hover'],
                    },
                    ...sx,
                }}
                {...props}
            >
                {children}
            </Box>
        );
    }
); 